<i class="material-icons" (click)='edit()'>edit</i>
  <i class="material-icons" (click)="getPDF()">picture_as_pdf</i>
  <i class="material-icons" (click)="view()">pageview</i>